import SiteCards from "../components/registration/SiteCards.vue";
import Vue from 'vue';
import $ from 'jquery';
import client from 'lib/axios';
import { camelizeKeys } from 'humps';

let siteCardsVm: InstanceType<typeof Vue>;

const getSiteCards = () => {
  return siteCardsVm ? siteCardsVm.$children[0] as any : undefined;
}

// 高専・専門学校の学生は文理が任意なので、未選択でも同時登録サイトを出す（文理不問のサイトのみが対象になる）。
// 学校種別は users.js.coffee が大学選択に連動して data-school-type へ書き込む
const isVocationalOrTechnicalSchool = () => {
  const schoolType = $('.js-registration-university:not([disabled])').attr('data-school-type');
  return schoolType === 'technical_school' || schoolType === 'vocational_school';
}

// jQueryで実装された大学選択等のUIと vue.js で作られた同時登録サイト選択UIを無理やり連携させるために
// Vue のルートインスタンスからコンポーネントを取り出してメソッドを直接呼ぶ
const updateSiteCards = async () => {
  const siteCards = getSiteCards();
  if (siteCards == null) return;

  const universityId: string | undefined = $('.js-registration-university:not([disabled])').val();
  const manualUniversity: string | undefined = $('.js-registration-manual-university:not([disabled])').val();
  const graduateYear: string = $('.js-registration-graduate-year').val();
  const businessCategoryIds: string[] = $('.js-registration-wannabe_business_categories').map((_, elem) => $(elem).val()).toArray();
  const highSchoolId: string | undefined = $('#user_high_school_id:not([disabled])').val();
  const hasUniversity = (manualUniversity != null && manualUniversity !== '') || (universityId != null && universityId !== '');
  const course: string | null = $('.js-registration-course:checked').val();
  if (hasUniversity && graduateYear != null && graduateYear !== '' && (course != null || isVocationalOrTechnicalSchool())) {
    const { data } = await client.get('/users/site_registrations', {
      params: {
        university_id: universityId,
        manual_university: manualUniversity,
        graduate_year: graduateYear,
        business_category_ids: businessCategoryIds,
        course,
        high_school_id: highSchoolId,
      }
    });
    siteCards.setSites(camelizeKeys(data));
  } else {
    siteCards.setSites([]);
  }
}

const initLegacyUI = () => {
  const $elems = $('.js-registration-university, .js-registration-graduate-year, .js-registration-manual-university, .js-registration-course, .js-registration-wannabe_business_categories, #user_high_school_id');
  if ($elems.length == 0) return;

  $elems.change(() => {
    updateSiteCards();
  });
  // 大学の change の時点では学校種別の取得（非同期）が終わっていないため、確定した時点でも呼び直す
  $(document).on('school-type:changed', () => {
    updateSiteCards();
  });
  updateSiteCards();
};

const getProps = () => {
  const elem = document.getElementById('js-site-cards');
  if (elem == null) return;
  const dataIds = elem.dataset.checkedSiteIds;
  return {
    initialCheckedSiteIds: dataIds ? JSON.parse(dataIds) : [],
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const props = getProps();
  if (props == null) return;

  const vm = new Vue({
    el: '#js-site-cards',
    render: h => h(SiteCards, { props })
  });
  siteCardsVm = vm;

  initLegacyUI();
});
